module.exports = {
          srcSet: __webpack_public_path__ + "d263cd87ccdd8038700f93636f318c09-959.png"+" 959w",
          images:[ {path: __webpack_public_path__ + "d263cd87ccdd8038700f93636f318c09-959.png",width: 959,height: 543}],
          src: __webpack_public_path__ + "d263cd87ccdd8038700f93636f318c09-959.png",
          toString:function(){return __webpack_public_path__ + "d263cd87ccdd8038700f93636f318c09-959.png"},
          
          width: 959,
          height: 543
        }